const EvaluationHeader = ({
  studentName,
  bookTitle,
  currentLevel,
  onClose,
}) => {
  const titleDisplay = [studentName, bookTitle].filter(Boolean).join(" / ");

  return (
    <div
      className="d-flex align-items-center justify-content-between px-4 py-3 text-white"
      style={{
        backgroundColor: "#64c8e2",
        minHeight: "56px",
        direction: "rtl",
      }}
    >
      <div className="fw-bold" style={{ fontSize: "16px" }}>
        {titleDisplay}
      </div>

      {currentLevel && (
        <div className="fw-bold text-center" style={{ fontSize: "16px" }}>
          المستوى الحالي: {currentLevel}
        </div>
      )}

      <div>
        <button
          type="button"
          className="btn btn-link text-white p-0 text-decoration-none border-0"
          onClick={onClose}
          style={{ fontSize: "22px", lineHeight: "1" }}
          aria-label="إغلاق"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default EvaluationHeader;
